var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-patient-icon",class:_vm.cls,attrs:{"title":_vm.$t(_vm.status)}},[_c('img'),_c('i',{staticClass:"fa fa-circle w3-black fa-xs"})])}
var staticRenderFns = []

export { render, staticRenderFns }